// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-bar {
  width: 50%;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 16px;
  width: 20px;
  height: 20px;
  color: #6b7280;
}

.search-input {
  width: 100%;
  padding: 12px 16px 12px 48px;
  border: 1px solid #2c3948;
  border-radius: 50px;
  font-size: 1.6rem;
  font-family: "Inter", sans-serif;
  outline: none;
  transition: all 0.2s ease;
}

.search-input:focus {
  border-color: #f97316;
  box-shadow: 0 0 0 2px rgba(218, 112, 39, 0.1);
}

.search-input::placeholder {
  color: #2c3948;
  font-size: 1.8rem;
  font-weight: 400;
}

.search-icon {
  width: 28px;
  height: 28px;
}

.search-loading {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 16px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #f97316;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Bouton pour effacer la recherche */
.clear-button {
  position: absolute;
  right: 16px;
  background: none;
  border: none;
  font-size: 2.8rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  line-height: 1;
}

.clear-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}

.clear-button:active {
  background-color: #e5e7eb;
}
.modal-articles-search.disabled {
  opacity: 0.5; /* rend visuellement grisé */
  /* pointer-events: none; <-- retirer */
  position: relative;
}

/* Désactiver l'input et le curseur */
.modal-articles-search.disabled .search-input {
  background-color: #f0f0f0; /* gris clair */
  cursor: not-allowed;
  pointer-events: none; /* bloque juste l'input */
}

/* Désactiver le bouton clear si besoin */
.modal-articles-search.disabled .clear-button {
  pointer-events: none;
}

/* Tooltip */
.modal-articles-search.disabled::before {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px 10px;
  background-color: #333;
  color: #fff;
  border-radius: 4px;
  white-space: nowrap;
  font-size: 12px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
  pointer-events: none;
  margin-bottom: 5px;
  z-index: 100;
}

.modal-articles-search.disabled::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #333 transparent;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
}

/* Afficher le tooltip au hover */
.modal-articles-search.disabled:hover::before,
.modal-articles-search.disabled:hover::after {
  opacity: 1;
  visibility: visible;
}
`, "",{"version":3,"sources":["webpack://./src/composants/SearchBar/SearchBar.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY,EAAE,4BAA4B;EAC1C,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,yBAAyB,EAAE,eAAe;EAC1C,mBAAmB;EACnB,oBAAoB,EAAE,yBAAyB;AACjD;;AAEA,yCAAyC;AACzC;EACE,oBAAoB;AACtB;;AAEA,YAAY;AACZ;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,yCAAyC;EACzC,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;EACtD,UAAU;EACV,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,iCAAiC;AACjC;;EAEE,UAAU;EACV,mBAAmB;AACrB","sourcesContent":[".search-bar {\r\n  width: 50%;\r\n}\r\n\r\n.search-input-wrapper {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.search-icon {\r\n  position: absolute;\r\n  left: 16px;\r\n  width: 20px;\r\n  height: 20px;\r\n  color: #6b7280;\r\n}\r\n\r\n.search-input {\r\n  width: 100%;\r\n  padding: 12px 16px 12px 48px;\r\n  border: 1px solid #2c3948;\r\n  border-radius: 50px;\r\n  font-size: 1.6rem;\r\n  font-family: \"Inter\", sans-serif;\r\n  outline: none;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.search-input:focus {\r\n  border-color: #f97316;\r\n  box-shadow: 0 0 0 2px rgba(218, 112, 39, 0.1);\r\n}\r\n\r\n.search-input::placeholder {\r\n  color: #2c3948;\r\n  font-size: 1.8rem;\r\n  font-weight: 400;\r\n}\r\n\r\n.search-icon {\r\n  width: 28px;\r\n  height: 28px;\r\n}\r\n\r\n.search-loading {\r\n  width: 20px;\r\n  height: 20px;\r\n  position: absolute;\r\n  left: 16px;\r\n  border: 2px solid #f3f3f3;\r\n  border-top: 2px solid #f97316;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/* Bouton pour effacer la recherche */\r\n.clear-button {\r\n  position: absolute;\r\n  right: 16px;\r\n  background: none;\r\n  border: none;\r\n  font-size: 2.8rem;\r\n  color: #6b7280;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  width: 32px;\r\n  height: 32px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  transition: all 0.2s ease;\r\n  line-height: 1;\r\n}\r\n\r\n.clear-button:hover {\r\n  background-color: #f3f4f6;\r\n  color: #374151;\r\n}\r\n\r\n.clear-button:active {\r\n  background-color: #e5e7eb;\r\n}\r\n.modal-articles-search.disabled {\r\n  opacity: 0.5; /* rend visuellement grisé */\r\n  /* pointer-events: none; <-- retirer */\r\n  position: relative;\r\n}\r\n\r\n/* Désactiver l'input et le curseur */\r\n.modal-articles-search.disabled .search-input {\r\n  background-color: #f0f0f0; /* gris clair */\r\n  cursor: not-allowed;\r\n  pointer-events: none; /* bloque juste l'input */\r\n}\r\n\r\n/* Désactiver le bouton clear si besoin */\r\n.modal-articles-search.disabled .clear-button {\r\n  pointer-events: none;\r\n}\r\n\r\n/* Tooltip */\r\n.modal-articles-search.disabled::before {\r\n  content: attr(data-tooltip);\r\n  position: absolute;\r\n  bottom: 100%;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  padding: 5px 10px;\r\n  background-color: #333;\r\n  color: #fff;\r\n  border-radius: 4px;\r\n  white-space: nowrap;\r\n  font-size: 12px;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transition: opacity 0.3s, visibility 0.3s;\r\n  pointer-events: none;\r\n  margin-bottom: 5px;\r\n  z-index: 100;\r\n}\r\n\r\n.modal-articles-search.disabled::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  bottom: 100%;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  border-width: 5px;\r\n  border-style: solid;\r\n  border-color: transparent transparent #333 transparent;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transition: opacity 0.3s, visibility 0.3s;\r\n}\r\n\r\n/* Afficher le tooltip au hover */\r\n.modal-articles-search.disabled:hover::before,\r\n.modal-articles-search.disabled:hover::after {\r\n  opacity: 1;\r\n  visibility: visible;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
